import TexarkanaHeroSection from "./components/HeroSection";
import TexarkanaStickyNav from "./components/StickyNav";
import TexarkanaProcessingTimeSection from "./components/ProcessingTimeSection";
import TexarkanaServicesSection from "./components/ServicesSection";
import TexarkanaLocalAreaSection from "./components/LocalAreaSection";
import TexarkanaTravelTimingSection from "./components/TravelTimingSection";
import TexarkanaDestinationsSection from "./components/DestinationsSection";
import TexarkanaTestimonialsSection from "./components/TestimonialsSection";
import TexarkanaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import TexarkanaComparisonSection from "./components/ComparisonSection";
import TexarkanaMistakesSection from "./components/MistakesSection";
import TexarkanaHowItWorksSection from "./components/HowItWorksSection";
import TexarkanaFAQSection, { faqs } from "./components/FAQSection";
import TexarkanaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TexarkanaFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function TexarkanaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Texarkana"
        state="Arkansas"
        stateAbbr="AR"
        route="/texarkana"
        title="Emergency Passport Texarkana, AR — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Texarkana, AR — as fast as 24 hours. Serving railroad professionals, college students, and Ark-La-Tex mission teams. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Texarkana, Arkansas"
        geoPosition="33.4418;-94.0477"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Arkansas"
        statePageRoute="/states/arkansas"
      />
      <TexarkanaHeroSection />
      <TexarkanaStickyNav />
      <TexarkanaProcessingTimeSection />
      <TexarkanaLocalAreaSection />
      <TexarkanaServicesSection />
      <TexarkanaTravelTimingSection />
      <TexarkanaDestinationsSection />
      <TexarkanaTestimonialsSection />
      <TexarkanaAcceptanceFacilitiesSection />
      <TexarkanaComparisonSection />
      <TexarkanaMistakesSection />
      <TexarkanaHowItWorksSection />
      <TexarkanaFAQSection />
      <TexarkanaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/texarkana" state="AR" />
      <TexarkanaFinalCTA />
    </div>
  );
}